import { useCallback } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";

import { slideDetailLabel } from "shared/utils/slideUtils";

import AdminLayout from "components/admin/AdminLayout";
import CaseEditController from "components/admin/editCasePanel/CaseEditController";
import ApplicationState from "store/ApplicationState";

const AdminCasePage = () => {
  const adminCase = useSelector(({ admin }: ApplicationState) => admin.case);
  const adminSlide = useSelector(({ admin }: ApplicationState) => admin.slide);
  const adminDocument = useSelector(
    ({ admin }: ApplicationState) => admin.document?.document
  );

  const getTitle = useCallback(() => {
    if (adminDocument) {
      return ` - Document ${adminDocument.name}`;
    } else if (adminSlide) {
      return ` - Slide ${adminSlide.accession_number} ${slideDetailLabel(
        adminSlide
      )}`;
    } else if (adminCase) {
      return ` - Case ${adminCase.accession}`;
    } else {
      return "";
    }
  }, [adminCase, adminSlide, adminDocument]);

  return (
    <AdminLayout>
      <>
        <Helmet>
          <title>QC Admin{getTitle()} - PathologyWatch</title>
        </Helmet>
        <CaseEditController />
      </>
    </AdminLayout>
  );
};

export default AdminCasePage;
